import { editorState } from "@app/store/editorStore.svelte.js";

const DEFAULT_PAUSE_DURATION_MS = 500;

let resumeTimer = null;
// Only resume playback that this module paused, never a user's manual pause.
let pausedByTyping = false;

function getPauseDuration() {
    const duration = Number(editorState.pauseWhileTypeDuration);
    return Number.isFinite(duration) && duration > 0
        ? duration
        : DEFAULT_PAUSE_DURATION_MS;
}

/**
 * Debounced pause: every keystroke pauses playback (if playing) and pushes
 * the resume back until the user has stopped typing for the configured duration.
 */
export function pauseWhileTyping() {
    if (!editorState.pauseWhileTyping) {
        return;
    }

    const player = window.player;
    if (!player) {
        return;
    }

    if (player.state?.playing) {
        player.pause();
        pausedByTyping = true;
    }

    if (!pausedByTyping) {
        return;
    }

    clearTimeout(resumeTimer);
    resumeTimer = setTimeout(() => {
        resumeTimer = null;
        if (!pausedByTyping) {
            return;
        }

        pausedByTyping = false;
        const currentPlayer = window.player;
        if (currentPlayer && !currentPlayer.state?.playing) {
            currentPlayer.play();
        }
    }, getPauseDuration());
}
